export default __webpack_public_path__ + "static/media/de_DE.3d31cf85.svg";